import { render, staticRenderFns } from "./BuilderTranslation.vue?vue&type=template&id=6b070b1b&scoped=true&"
import script from "./BuilderTranslation.vue?vue&type=script&lang=js&"
export * from "./BuilderTranslation.vue?vue&type=script&lang=js&"
import style0 from "./BuilderTranslation.vue?vue&type=style&index=0&id=6b070b1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b070b1b",
  null
  
)

export default component.exports